export const f = (code: string = '') => code.trim();
